module.exports = __webpack_public_path__ + "static/media/SILKSERIF-REGULAR.a1c64e9a.woff2";